/* hs-eslint ignored failing-rules */

/* eslint-disable prefer-promise-reject-errors */
import { canUseExistingUserSignupEndpoint } from '../app/verificationTypeSelectors';
import { isQA } from '../constants/apiEnvironments';
import { getCompleteVerificationBody } from '../http-complete-verification/getCompleteVerificationBody';
import { getInitiateVerificationBody } from '../http-initiate-verification/getInitiateVerificationBody';
import { getSignupBody } from '../http-signup/getSignupBody';
import noAuthApiClient from '../http/noAuthApiClient';
import noPortalApiClient from '../http/noPortalApiClient';
import { isRecaptchaTest } from '../selenium/seleniumFeatures';
import { Tracker } from '../store/tracking/action-creators';
import { getCompleteVerificationPath, getInitiateVerificationPath, getSignupPath } from './signupClientPaths';

const initiateVerification = (state, dispatch) => {
  dispatch(Tracker.signupInteraction('send-verification-email-request'));
  return noAuthApiClient.post(getInitiateVerificationPath(), {
    data: getInitiateVerificationBody(state)
  });
};

const completeVerification = state => {
  return noAuthApiClient.post(getCompleteVerificationPath(state), {
    data: getCompleteVerificationBody(state)
  });
};

const signup = state => {
  if (isRecaptchaTest() && isQA) {
    return Promise.reject({
      status: 403,
      data: '{ "message": "recaptcha failed"}'
    });
  }

  let httpClient = noAuthApiClient;

  if (canUseExistingUserSignupEndpoint(state)) {
    httpClient = noPortalApiClient;
  }

  return httpClient.post(getSignupPath(state), {
    data: getSignupBody(state),
    timeout: 6000
  });
};

const SignupClient = {
  initiateVerification,
  completeVerification,
  signup
};
export default SignupClient;